import { Module } from '@nestjs/common'
import { TerminusModule } from '@nestjs/terminus'
import { HealthController } from './health.controller'
import { AppHealthIndicator, RedisHealthIndicator } from './indicators'

@Module({
	imports: [TerminusModule],
	controllers: [HealthController],
	providers: [AppHealthIndicator, RedisHealthIndicator],
})
export class HealthModule {}
